import { render, staticRenderFns } from "./WeekScheduleCard.vue?vue&type=template&id=45bde568&scoped=true"
import script from "./WeekScheduleCard.vue?vue&type=script&lang=js"
export * from "./WeekScheduleCard.vue?vue&type=script&lang=js"
import style0 from "./WeekScheduleCard.vue?vue&type=style&index=0&id=45bde568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bde568",
  null
  
)

export default component.exports